import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _entities = [];
let _stats = {};

let AddressStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    emitChangeForm: function() {
        this.emit(FORM_CHANGE_EVENT);
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getById: function(id) {
        return _entities[id];
    },
    getAll: function() {
         return _entities;
    },
    add: function(entity) {
        _entities[entity.id] = entity;
    },
    update: function(entity) {
        _entities[entity.id] = entity;
    },
    delete: function(id) {
        delete _entities[id];
    },

});

AddressStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.ADDRESS_INFO:
            _entities[action.data.id] = action.data;
            AddressStore.emitChange();
            break;

        case ActionTypes.ADDRESS_INFO_ERROR:
            AddressStore.emitChange();
            break;

        case ActionTypes.ADDRESS_SAVE:
            AddressStore.add(action.data);
            AddressStore.emitChange();
            break;

        case ActionTypes.ADDRESS_UPDATE:
            AddressStore.update(action.data);
            AddressStore.emitChange();
            break;

        default:
            break;

    }

});

export default AddressStore;
